// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"122099b5","183":"18866ad9","294":"e01f3e38","299":"58065886","453":"f0a47a34","561":"df4f29f7","815":"05ca71e0","816":"ea747410","824":"273a5ad6","989":"5448c78d"}[chunkId] + ".chunk.js";
};